import React from 'react'
import { connect } from 'react-redux'
import {dashboardSetActiveUpdateText, dashboardSetDisplayUpdateHistory } from '../../actions'
import toJS from '../general/toJS'
import DashboardUpdatetext from '../../components/PageDashboard/DashboardUpdatetext';
import getData from '../../functions/getData';
import { CLI_CINEMA_CLIENT_ID, PROGRAM_CINEMAS } from '../../constants/state';

const mapDispatchToProps = (dispatch, ownProps) => ({
    collapseActiveUpdateText: (activeClass, id) => {
        const activeUpdateTextID = activeClass === "update-text-open" ? '' : id
        dispatch(dashboardSetActiveUpdateText(activeUpdateTextID))
    },
    toggleUpdateHistory: (displayUpdateHistory) => {
        dispatch(dashboardSetDisplayUpdateHistory(!displayUpdateHistory))
    }
})

const mapStateToProps = (state, ownProps) => ({
    activeUpdateText: state.getIn(['ui', 'dashboard', 'activeUpdateText']),
    displayUpdateHistory: state.getIn(['ui', 'dashboard', 'displayUpdateHistory']),
    cinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const DashboardUpdatetextContainer = ({collapseActiveUpdateText, activeUpdateText, toggleUpdateHistory, displayUpdateHistory, cinemas, clientCinemaId}) => { 
    let cinemaProviderArr = []

    if(cinemas[clientCinemaId]) {
        if(cinemas[clientCinemaId].scope.type === "multi") {
            cinemas[clientCinemaId].scope.cinemas.map(singleCinemaId => {
                const cinema = cinemas[singleCinemaId]
                const cinemaProvider = cinema.scope.cinemaDataProvider.type
    
                if(!_.contains(cinemaProviderArr, cinemaProvider)) {
                    cinemaProviderArr.push(cinemaProvider)
                }
            })
        } else if(cinemas[clientCinemaId].scope.type === "single") {
            const cinemaProvider = cinemas[clientCinemaId].scope.cinemaDataProvider.type
            
            if(!_.contains(cinemaProviderArr, cinemaProvider)) {
                cinemaProviderArr.push(cinemaProvider)
            }
        }
    }

    return (
        <DashboardUpdatetext
            collapseActiveUpdateText={collapseActiveUpdateText}
            activeUpdateText={activeUpdateText}
            displayUpdateHistory={displayUpdateHistory}
            toggleUpdateHistory={toggleUpdateHistory}
            cinemaProviderArr={cinemaProviderArr}
        />
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(DashboardUpdatetextContainer))